import { graphql } from 'react-relay';
import { useRelayFetchQuery } from '../relay.utils';
import type { GCP_VertexSearchPagination_Query$variables } from './__generated__/GCP_VertexSearchPagination_Query.graphql';
import type { GCP_VertexSearch_Single_Query } from './__generated__/GCP_VertexSearch_Single_Query.graphql';
import type { GCP_vertexGenAi_Query } from './__generated__/GCP_vertexGenAi_Query.graphql';

export * from './__generated__/GCP_vertexGenAi_Query.graphql';
export const VertexGenAiQuery = graphql`
  query GCP_vertexGenAi_Query(
    $url: String,
    $mediaItemId: ID,
    $promptType: VertexGenAIPromptType,
    $customPrompt: String
  ) {
    vertexGenAi(
      url: $url,
      mediaItemId: $mediaItemId,
      promptType: $promptType,
      customPrompt: $customPrompt
    ) {
      summary
    }
  }
`;

export const useVertexGenAiQuery = () => {
  return useRelayFetchQuery<GCP_vertexGenAi_Query>(VertexGenAiQuery);
};

const VertexSearchAgentFragment = graphql`
  fragment GCP_VertexSearchAgent_Summary_Fragment on Summary {
    summaryText
    summaryWithMetadata {
      summary
      citationMetadata {
        citations {
          startIndex
          endIndex
          sources {
            referenceIndex
          }
        }
      }
      references {
        title
        document
      } 
    }
  }
`;

export type GCP_VertexSearchPagination_Fragment$args = GCP_VertexSearchPagination_Query$variables;

export * from './__generated__/GCP_VertexSearchPagination_Fragment.graphql';
export const VertexSearchAgentPaginationFragment = graphql`
  fragment GCP_VertexSearchPagination_Fragment on RootQuery 
   @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "VertexSearchAgentConnectionWhereArgs" }
  )
  @refetchable(queryName: "GCP_VertexSearchPagination_Query") {
    vertexSearchAgent(first: $first, after: $after, where: $where)
      @connection(key: "GCP_Pagination_vertexSearchAgent") {
        correctedQuery
        summary {
          ...GCP_VertexSearchAgent_Summary_Fragment @relay(mask: false)
        }
        edges {
          node {
            ...ZnglyVideo_Single_Fragment @relay(mask: false)
          }
        }
      }
  }
`;

export type {
  GCP_VertexSearch_Query,
  GCP_VertexSearch_Query$data,
  GCP_VertexSearch_Query$variables,
} from './__generated__/GCP_VertexSearch_Query.graphql';
export const VertexSearchAgentQuery = graphql`
  query GCP_VertexSearch_Query($where: VertexSearchAgentConnectionWhereArgs = null) {
    ...GCP_VertexSearchPagination_Fragment @arguments(first: 100, after: null, where: $where)
  }
`;

export type {
  GCP_VertexSearch_Single_Query,
  GCP_VertexSearch_Single_Query$data,
  GCP_VertexSearch_Single_Query$variables,
} from './__generated__/GCP_VertexSearch_Single_Query.graphql';
export const useVertexSearchAgentQuery = () => {
  return useRelayFetchQuery<GCP_VertexSearch_Single_Query>(graphql`
      query GCP_VertexSearch_Single_Query($where: VertexSearchAgentConnectionWhereArgs = null) {
        vertexSearchAgent(first: 100, after: null, where: $where) {
          correctedQuery
          summary {
            ...GCP_VertexSearchAgent_Summary_Fragment @relay(mask: false)
          }
          edges {
            node {
              ...ZnglyVideo_Single_Fragment @relay(mask: false)
            }
          }
        }
      }
    `);
};
